module.exports = __webpack_public_path__ + "img/PM.24fd396f.svg";